import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router, RoutesRecognized } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { UtilityService } from '../services/utility.service';
import { PolicyService } from '../services/policy.service';

@Component({
    selector: 'pq-header-nav',
    templateUrl: './header-nav.component.html',
    styleUrls: ['./header-nav.component.css'],
    standalone: false
})
export class HeaderNavComponent implements OnInit {
  buttonText = 'Login';
  welcomeLabel: string = '';
  isAdministration: boolean = false;
  logoPath: string = '';
  logoStyle: string = '';

  menuItems!: MenuItem[];
  constructor(
    private authService: AuthService,
    private router: Router,
    private utilityService: UtilityService,
    private policyService: PolicyService
  ) {}

  ngOnInit(): void {
    this.getSiteLogo();
    this.router.events.subscribe((event) => {
      if (event instanceof RoutesRecognized) {
        var firstChild = event.state.root.firstChild;
        if (firstChild?.routeConfig?.path === 'resetpassword') return;
      }
    });

    // Subscribe to user changes
    this.authService.currentUserO.subscribe({
      next: (user) => {
        if (user) {
          this.buttonText = 'Logout';
          this.welcomeLabel =
            `${user!.firstName}  ${user!.lastName}`.length > 0
              ? `Welcome, ${user!.firstName}  ${user!.lastName}`
              : '';
          this.loadMenu();
        } else {
          this.buttonText = 'Login';
          this.welcomeLabel = '';
          this.loadMenu();
        }
      },
    });
  }

  async logInOut() {
    if (this.buttonText === 'Logout') {
      await this.authService.logout();
    } else {
      this.router.navigate(['/login']);
    }
  }

  loadMenu() {
    // Get the first role from roles array
    const userRole = this.authService.currentUser?.roles?.[0] ?? '';
    var showMenu = this.policyService.isRoleInPolicy(
      'UserAdministration',
      userRole
    );

    if (showMenu) {
      this.menuItems = [
        {
          label: 'Quote Request',
          routerLink: ['/quoteRequest'],
        },
        {
          label: 'User Management',
          routerLink: ['/admin'],
        },
      ];

      if (this.authService.isDfsOversight()) {
        this.menuItems.push({
          label: 'Admin Tool',
          routerLink: ['/admin/admin-tool'],
        });
      }
    } else {
      this.menuItems = [];
    }
  }

  private getSiteLogo() {
    var logo = this.utilityService.siteLogo;

    this.logoPath = logo.path;

    if (logo.height) {
      this.logoStyle += `height: ${logo.height}px; `;
    }
    if (logo.width) {
      this.logoStyle += `width: ${logo.width}px; `;
    }
  }
}
